export default "__VITE_ASSET__rcJWfAsue32XwR1kdhKJSw__"